import React, {useState} from "react";
import {InputTextarea} from "primereact/inputtextarea";
import {Calendar} from "primereact/calendar";
import {Button} from "primereact/button";
import axios from "axios";
import {base} from "../../../api";

export default function CancelContractDialog({
	cancelContractData,
	setCancelContractDialogVisibility,
}) {
	const [cancelDate, setCancelDate] = useState(null);
	const [reason, setReason] = useState("");

	const handleSubmit = async () => {
		if (!cancelDate || !reason.trim()) return;

		const payload = {
			contract_id: cancelContractData?.id,
			cancel_date: cancelDate,
			reason,
		};

		try {
			await axios.post(`${base}/contracts/cancel/`, payload);
			setCancelContractDialogVisibility(false);
		} catch (error) {
			console.error("Error cancelling contract:", error);
		}
	};

	return (
		<div>
			<div className="col-12 mb-3">
				Պայմանագիր համար N {cancelContractData?.formatted_contract_number}
			</div>
			<div className="col-12 mb-3">
				<Calendar
					className="w-100"
					value={cancelDate}
					onChange={e => setCancelDate(e.value)}
					showIcon
				/>
			</div>
			<div className="col-12 mb-3">
				<InputTextarea
					className="w-100"
					value={reason}
					onChange={e => setReason(e.target.value)}
					rows={3}
					placeholder="Enter cancellation reason..."
				/>
			</div>
			<div className="col-12 text-center d-flex justify-content-center border-top pt-3">
				<Button
					label="Cancel"
					text
					rounded
					severity="secondary"
					className="me-2"
					onClick={() => setCancelContractDialogVisibility(false)}
				/>
				<Button
					label="Submit"
					rounded
					severity="primary"
					className="me-2"
					onClick={handleSubmit}
					disabled={!cancelDate || !reason.trim()}
				/>
			</div>
		</div>
	);
}
